import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll'
import './style.css'

const Scrollbar = () => {

    return (
        <div className="col-lg-12">
            <div className="header-menu">
                <ul className="smothscroll">
                    <li><AnchorLink href='#scrool' >
                        {/* <i className="ti-arrow-up"></i> */}
                        <svg className="up-arrow-icon" viewBox="0 0 24 24">
                            <path d="M12 4l-8 8h5v8h6v-8h5z" />
                        </svg>
                    </AnchorLink></li>
                </ul>
            </div>
        </div>

    )
}

export default Scrollbar;
